export enum CheckBoxVariant {
  default = 'default',
  mixed = 'mixed',
  rounded = 'rounded',
  small = 'small'
}
